import React from "react";
import { MessageCircle, Phone } from "lucide-react";
import { WHATSAPP_URL, TEL_URL, PHONE } from "@/lib/brand";

export default function FinalCTA() {
  return (
    <section data-testid="final-cta-section" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="relative overflow-hidden rounded-[36px] bg-[var(--gf-primary)] text-white p-10 lg:p-16">
          <div className="absolute inset-0 gf-grid-bg opacity-25 pointer-events-none" />
          <div className="absolute -top-32 -right-20 h-[420px] w-[420px] rounded-full bg-[var(--gf-blue)]/40 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-32 -left-20 h-[360px] w-[360px] rounded-full bg-[var(--gf-green)]/30 blur-3xl pointer-events-none" />

          <div className="relative max-w-3xl">
            <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 px-3.5 py-1.5 rounded-full text-xs font-semibold tracking-wide">
              <span className="h-2 w-2 rounded-full bg-[var(--gf-green)] gf-pulse-dot" />
              50% OFF — Launch offer
            </div>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.05]">
              Start getting more customers from Google — today.
            </h2>
            <p className="mt-5 text-lg text-white/80 max-w-2xl">
              Stop losing patients to competitors. Get a high-converting landing page live in 48 hours and turn
              every Google search into a real WhatsApp inquiry or call.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="final-whatsapp-btn"
                className="inline-flex justify-center items-center gap-2.5 bg-[var(--gf-green)] hover:bg-[var(--gf-green-deep)] text-white font-semibold h-14 px-7 rounded-full text-base"
              >
                <MessageCircle className="h-5 w-5" /> WhatsApp Now
              </a>
              <a
                href={TEL_URL}
                data-testid="final-call-btn"
                className="inline-flex justify-center items-center gap-2.5 bg-white text-[var(--gf-primary)] font-semibold h-14 px-7 rounded-full text-base"
              >
                <Phone className="h-5 w-5" /> Call {PHONE}
              </a>
              <a
                href="#lead-form"
                data-testid="final-demo-btn"
                className="inline-flex justify-center items-center gap-2.5 border-2 border-white/30 hover:border-white/60 text-white font-semibold h-14 px-7 rounded-full text-base"
              >
                Get free demo page
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
